import Data7 from '@/assets/icons/icon-card-tick.svg';
import Data1 from '@/assets/icons/menu-lists/1.svg';
import Data2 from '@/assets/icons/menu-lists/2.svg';
import Data3 from '@/assets/icons/menu-lists/3.svg';
import Data4 from '@/assets/icons/menu-lists/4.svg';
import Data5 from '@/assets/icons/menu-lists/5.svg';
import Data6 from '@/assets/icons/menu-lists/6.svg';
import { useTranslations } from 'next-intl';

export const profileListsData = () => {
  const t = useTranslations('Pages');
  return [
    {
      title: t('orders.title'),
      icon: <Data1 />,
      slug: 'order',
    },
    {
      title: t('bonuses.title'),
      icon: <Data2 />,
      slug: 'bonuses',
    },
    {
      title: t('history.title'),
      icon: <Data3 />,
      slug: 'history',
    },
    {
      title: t('comparison.title'),
      icon: <Data4 />,
      slug: 'comparison',
    },
    {
      title: t('favorites.title'),
      icon: <Data5 />,
      slug: 'favorites',
    },
    {
      title: t('personal-data.title'),
      icon: <Data6 />,
      slug: 'personal-data',
    },
    // {
    //   title: t('my-limit.title'),
    //   icon: <Data7 />,
    //   slug: 'my-limit',
    // },
  ];
};
